<div style="text-align:center">
    <button (click)="save()" [class.spinner]="loading" [color]="color" [disabled]="disabled" mat-raised-button>

        <i class="material-icons">
            {{icon}}
        </i> {{text}}</button>
</div>
